import { getName } from "country-list";
import moment from "moment";
import { DATE_FORMATS } from "../../../../../constants";
import { GENDER } from "../../../../student/types";
import { UserRole } from "../../../enums/UserRole";

export function parseToAccountFrontEndModel(
  userData: any,
  profile: any,
  userRole: UserRole,
) {
  const parsedProfile: any = {
    name: userData.name,
    email: userData.email,
    phone: userData.phone,
    role: userData.role,
  };

  if ([UserRole.Owner, UserRole.Admin, UserRole.Support].includes(userRole)) {
    return parsedProfile;
  }

  if (userRole === UserRole.School) {
    return parseToSchoolFrontEndModel();
  }

  if (userRole === UserRole.ServiceProvider) {
    return parseToServiceProviderFrontEndModel();
  }

  if (userRole === UserRole.Agent) {
    return parseToAgentFrontEndModel();
  }

  if (userRole === UserRole.Parent) {
    return parseToParentFrontEndModel();
  }

  if (userRole === UserRole.Student) {
    return parseToStudentFrontEndModel();
  }

  function parseToSchoolFrontEndModel() {
    parsedProfile.schoolProfile = {
      ...profile,
    };

    parsedProfile.image = profile.school?.image?.preview;

    if (typeof profile.school.country === "string") {
      parsedProfile.schoolProfile.school.country = {
        code: profile.school.country,
        name: getName(profile.school.country),
      };
    }

    return parsedProfile;
  }

  function parseToServiceProviderFrontEndModel() {
    parsedProfile.serviceProviderProfile = {
      ...profile,
    };

    parsedProfile.image = profile.serviceProvider?.image?.preview;

    if (typeof profile.serviceProvider.country === "string") {
      parsedProfile.serviceProviderProfile.serviceProvider.country = {
        code: profile.serviceProvider.country,
        name: getName(profile.serviceProvider.country),
      };
    }

    return parsedProfile;
  }

  function parseToAgentFrontEndModel() {
    parsedProfile.agentProfile = {
      ...profile,
    };

    parsedProfile.image = userData.photo?.preview;

    if (typeof profile.country === "string") {
      parsedProfile.agentProfile.country = {
        code: profile.country,
        name: getName(profile.country),
      };
    }

    return parsedProfile;
  }

  function parseToParentFrontEndModel() {
    parsedProfile.image = userData.photo?.preview;

    return parsedProfile;
  }

  function parseToStudentFrontEndModel() {
    parsedProfile.image = userData.photo?.preview;

    parsedProfile.studentProfile = {
      city: profile.city,
      birth_date:
        profile.birth_date && moment(profile.birth_date, DATE_FORMATS.frontEnd),
      country: profile.country && {
        code: profile.country,
        name: getName(profile.country),
      },
      citizenship: profile.country && {
        code: profile.citizenship,
        name: getName(profile.citizenship),
      },
      gender: profile.gender && {
        id: profile.gender,
        name: GENDER.find((item) => item.id === profile.gender)?.name,
      },
    };

    return parsedProfile;
  }
}
